import styled from '@emotion/styled'

const StylePagination = styled.div`
  display: flex;
  align-items: center;
  font-size: 14px;
  flex-wrap: wrap;
  color: rgba(0, 0, 0, 0.6);
  button {
    font-weight: 400;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.6);
    border: 1px solid #dcdcdc;
    :hover {
      border: 1px solid var(--ow-color-primary-700);
    }
  }
  .mantine-Pagination-active {
    color: #fff;
    border: 0;
    :hover {
      color: #fff;
      border: 0;
    }
  }
  .select {
    width: 100px;
    height: 32px;
    margin-right: 20px;
    border-radius: 4px;
    border: 1px solid var(--ow-color-primary-700);
    color: rgba(0, 0, 0, 0.9);
    background: transparent;
    outline: none;
    padding: 0 7px;
  }
  .total {
    margin-right: 20px;
  }
  .goto-page {
    margin-left: 20px;
    color: rgba(0, 0, 0, 0.9);
    display: flex;
    align-items: center;
  }
  .total-count {
    margin-left: 20px;
  }
  .mantine-Input-input {
    :hover,
    :focus {
      border-color: var(--ow-color-primary-700);
    }
  }
  .mantine-Select-input {
    :hover,
    :focus {
      border-color: var(--ow-color-primary-700);
    }
  }
`

export default StylePagination
